import { render, staticRenderFns } from "./TwitterIconWhite.vue?vue&type=template&id=5111d6ce&scoped=true"
import script from "./TwitterIconWhite.vue?vue&type=script&lang=ts"
export * from "./TwitterIconWhite.vue?vue&type=script&lang=ts"
import style0 from "./TwitterIconWhite.vue?vue&type=style&index=0&id=5111d6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5111d6ce",
  null
  
)

export default component.exports